export default __webpack_public_path__ + "static/media/SMK-Profile.ec7dcb8f.pdf";